export default __webpack_public_path__ + "static/media/1424.199940c8.png";